export function sortBy<T>(data: T[], key: string) {
  // @ts-ignore
  data = data.sort((a, b) => a[key].localeCompare(b.name));
  return data;
}
